import React from 'react';

const {
    Provider: JsonScreenProvider,
    Consumer: JsonScreenConsumer
} = React.createContext();

export {
    JsonScreenProvider,
    JsonScreenConsumer
};